import { AUTH_TOKEN_STORAGE_KEY } from '@/shared/config/auth';
/** 读取本地存储的会话令牌，非浏览器环境返回空值。 */
export function readStoredAuthToken() {
    if (typeof window === 'undefined')
        return null;
    return window.localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
}
/** 写入本地存储的会话令牌，登录成功后调用。 */
export function storeAuthToken(token) {
    if (typeof window === 'undefined')
        return;
    window.localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
}
/** 清除本地存储的会话令牌，登出和会话过期时调用。 */
export function clearStoredAuthToken() {
    if (typeof window === 'undefined')
        return;
    window.localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
}
